'use strict';


angular.module('myConsultApp')
  .filter('uriencode', function() {
       return function(input) {
          return window.encodeURIComponent(input);
       };
  });